// Chakra imports
import { Flex, Image, Text } from '@chakra-ui/react';

// Custom components
import { HSeparator } from 'components/separator/Separator';
import moment from 'moment';
import Logo from "../../../assets/img/logo/Byrd_Symbol_P.png";

export function SidebarBrand() {
	return (
		<Flex alignItems='center' flexDirection='column'>
			<Image src={Logo} style={{width: 128}} alt='Byrd Logo' />
			<Text padding={4} fontSize={12}>Versão - 0.0.4 - {moment(Date.now()).format('DD/MM/yyyy')}</Text>
			<HSeparator mb='20px' />
			
		</Flex>
	);
}

export default SidebarBrand;
